import React from 'react';
import './../assets/css/Common.css';

function AboutUs() {
  return (
    <div className='container page-container'>
      <div>
        <div style={{ flex: 1 }}>
          <h2 className='page-title'>ABOUT US</h2>
          <p>
            Welcome to Kalinga Ashram, a serene sanctuary nestled in nature's embrace, where the journey of self-discovery and inner peace begins. Our ashram offers a tranquil space for individuals seeking mindfulness, healing, and spiritual growth through time-honored practices.
          </p>
          <p>
            We provide immersive Meditation & Yoga Retreats to deepen awareness and mental clarity, along with Mindfulness & Spiritual Growth sessions that open the heart and mind. Our Holistic Healing environment supports physical, emotional, and spiritual well-being using traditional and natural methods.
          </p>
          <p>
            Kalinga Ashram is also home to a warm community of seekers and servers, united by a shared commitment to personal development and compassionate living. Whether you seek quiet reflection or meaningful connection, the ashram offers a sacred space to reconnect with yourself and others.
          </p>
          <p>
            Join us at Kalinga Ashram, where every breath invites calm and every step leads to deeper harmony.
          </p>


          <h3 style={{ marginTop: '30px', color: '#d87d0a', fontWeight: 'bold' }}>Our Mission</h3>
          <p>
            At Kalinga Ashram, we believe in the power of stillness and self-reflection to bring clarity and balance to the mind, body, and spirit. Our mission is to guide individuals on their path to personal growth and enlightenment through meditation, yoga, and a deep connection with nature. Whether you are seeking inner peace, spiritual awakening, or simply a respite from the demands of modern life, we offer a peaceful refuge where you can reconnect with yourself.
          </p>

          <h3 style={{ marginTop: '20px', color: '#d87d0a', fontWeight: 'bold' }}>What We Offer</h3>
          <ul>
            <li><strong>Meditation & Yoga Retreats:</strong> Experience a wide range of meditation techniques and yoga practices to deepen your awareness and achieve mental clarity.</li>
            <li><strong>Mindfulness & Spiritual Growth:</strong> Join our spiritual workshops and teachings designed to open your heart and mind, helping you cultivate mindfulness in your daily life.</li>
            <li><strong>Holistic Healing:</strong> We provide a nurturing environment for physical, emotional, and spiritual healing through traditional and natural practices.</li>
            <li><strong>Community & Service:</strong> Be part of a supportive community of like-minded individuals who share a common commitment to personal and spiritual development.</li>
          </ul>

          <h3 style={{ marginTop: '20px', color: '#d87d0a', fontWeight: 'bold' }}>Our Vision</h3>
          <p>
            We envision Kalinga Ashram as a place where people from all walks of life can come together to learn, grow, and support one another on their spiritual journeys. Through simple living and profound teachings, we hope to inspire a return to inner peace and a deeper understanding of the interconnectedness of all beings.
          </p>
          <p>
            Join us at Kalinga Ashram, and allow the serenity of our space and the wisdom of our teachings to guide you towards a life of fulfillment and harmony.
          </p>
        </div>
       
      </div>
    </div>
  );
}

export default AboutUs;
